module.exports = __webpack_public_path__ + "static/img/sixBox.3c7bf8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sixBox.png
// module id = 8aU/
// module chunks = 1